import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { AssistanceEditorComponent } from './assistance-editor.component'
import { PipesModule } from '../../../shared/pipes/pipes.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { IonicSelectableComponent } from 'ionic-selectable'
import { DatePickerModule, DateTimePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars'
import { AssistantSelectModule } from '../../assistant/assistant-select/assistant-select.module'
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor'
import { RecurrenceEditorModule } from '@syncfusion/ej2-angular-schedule'
import { AssistantFeedbackViewerComponent } from './assistant-feedback-viewer/assistant-feedback-viewer.component'
import { ExtractFeedbackMessagePipe } from './assistant-feedback-viewer/extract-feedback-message.pipe'
import { SanitizeHtmlPipeModule } from '../../../shared/pipes/bypass-html-sanitizer.pipe'
import { AssistantSelectComponent } from '../../assistant/assistant-select/components/assistant-select/assistant-select.component'
import { AssistanceEditorAssistanceStatusComponent } from './assistance-editor-assistance-status/assistance-editor-assistance-status.component'
import { GenderSelectComponent } from './gender-select/gender-select.component'
import { ClientSelectComponent } from './client-select/client-select.component'
import { KeyCoordinatorSelectComponent } from './key-coordinator-select/key-coordinator-select.component'
import { AssistanceEditorRecurrenceEditorComponent } from './assistance-editor-recurrence-editor/assistance-editor-recurrence-editor.component'
import { AssistanceEditorAssistantSelectComponent } from './assistance-editor-assistant-select/assistance-editor-assistant-select.component'
import { AssistanceEditorFinanceViewerComponent } from './assistance-editor-finance-viewer/assistance-editor-finance-viewer.component'
import { DateTimeInputComponent } from '../../../components/date-time-input/date-time-input.component'
import { TagEditorComponent } from '../../event/components/tag-editor/tag-editor.component'

@NgModule({
  declarations: [AssistanceEditorComponent, AssistantFeedbackViewerComponent, ExtractFeedbackMessagePipe],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    FontAwesomeModule,
    PipesModule,
    ReactiveFormsModule,
    IonicSelectableComponent,
    DatePickerModule,
    TimePickerModule,
    DateTimePickerModule,
    AssistantSelectModule,
    RichTextEditorModule,
    RecurrenceEditorModule,
    SanitizeHtmlPipeModule,
    AssistantSelectComponent,
    DateTimeInputComponent,
    GenderSelectComponent,
    ClientSelectComponent,
    KeyCoordinatorSelectComponent,
    AssistanceEditorAssistanceStatusComponent,
    AssistanceEditorRecurrenceEditorComponent,
    AssistanceEditorAssistantSelectComponent,
    AssistanceEditorFinanceViewerComponent,
    TagEditorComponent,
  ],
  exports: [AssistanceEditorComponent, AssistantFeedbackViewerComponent],
})
export class AssistanceEditorModule {}
